<div class="card">
    <div class="card-header" *ngIf="showButton">
        <a (click)="isCollapsed = ! isCollapsed" [attr.aria-expanded]="!isCollapsed" aria-controls="collapseExample"
            class="btn btn-outline-primary btn-block btn-lg">
            <i class="fas fa-tshirt"></i> Crear nuevo producto
        </a>
    </div>
    <div class="card-body" #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsed">
        <form [formGroup]="productoForm" *ngIf="productoForm">
            <div class="row justify-content-center">
                <div class="col-md-3">
                    <app-select label="Tipo" idForm="InputTipoProducto" [control]="productoForm.get('tipo_producto')"
                        [data]="tipoProductos" optValue="id_tipoproducto" optText="nombre_tipoproducto"></app-select>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label for="InputNombre">Nombre</label>
                        <input type="text" class="form-control" id="InputNombre" name="InputNombre"
                            placeholder="Ingresar nombre" autocomplete="off" [formControl]="productoForm.get('nombre')">
                    </div>
                </div>
                <div class="col-md-2">
                    <div class="form-group">
                        <label>Procesamiento</label>
                        <select class="custom-select" id="InputProcesamiento" name="InputProcesamiento"
                            [formControl]="productoForm.get('procesamiento')">
                            <option value="24">24h</option>
                            <option value="48">48h</option>
                            <option value="72">72h</option>
                            <option value="96">96h</option>
                            <option value="120">120h</option>
                            <option value="144">144h</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-md-3">
                    <div class="form-group">
                        <label for="InputValor">Valor</label>
                        <input type="text" class="form-control" id="InputValor" name="InputValor"
                            placeholder="Ingresar Valor" autocomplete="off" [formControl]="productoForm.get('valor')"
                            (input)="onlyNumber($event)">
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group">
                        <label for="InputCosto">Costo</label>
                        <input type="text" class="form-control" id="InputCosto" name="InputCosto"
                            placeholder="Ingresar Costo" autocomplete="off" [formControl]="productoForm.get('costo')"
                            (input)="onlyNumber($event)">
                    </div>
                </div>
                <div class="col-md-2">
                    <div class="form-group">
                        <label for="InputuseStock">Usa Stock</label>
                        <div class="custom-control custom-switch custom-switch-off-danger custom-switch-on-success">
                            <input type="checkbox" class="custom-control-input" id="edit_useStock" name="edit_useStock"
                                [formControl]="productoForm.get('useStock')">
                            <label class="custom-control-label" for="edit_useStock" id="edit_useStockText"></label>
                        </div>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group">
                        <label for="InputStock">Stock</label>
                        <input type="text" class="form-control" id="InputStock" name="InputStock" [readOnly]="!productoForm.get('useStock').value"
                            placeholder="Ingresar Stock" autocomplete="off" [formControl]="productoForm.get('stock')"
                            (input)="onlyNumber($event)">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <button type="button" name="add" class="btn btn-outline-success btn-block btn-lg"
                        (click)="GuardaProducto(productoForm.value)" [disabled]="!productoForm.valid">
                        <i class="fas fa-save"></i> Guardar
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>